import { defineStore } from 'pinia'
import { ref } from 'vue'

// Memória da sessão dos filtros das listas ("filtros travados", contrato
// `visita-aperfeicoamentos-navegacao-filtros-contract`, store partnercenter-specs). Guarda, por
// lista, a última query gravada por `useFiltrosNaUrl`, para restaurá-la quando a lista é aberta
// pelo menu. `sessionStorage`: some ao fechar a aba; o logout limpa (AuthAdminStore).
export const useFiltrosSessaoStore = defineStore('filtrosSessao', () => {
  const porLista = ref({})

  const lembrar = (chave, query) => {
    porLista.value = { ...porLista.value, [chave]: { ...query } }
  }

  const lembrado = (chave) => porLista.value[chave] || null

  const esquecer = (chave) => {
    const resto = { ...porLista.value }
    delete resto[chave]
    porLista.value = resto
  }

  const limparTudo = () => {
    porLista.value = {}
  }

  return { porLista, lembrar, lembrado, esquecer, limparTudo }
}, {
  persist: { storage: sessionStorage },
})
